import { render, staticRenderFns } from "./laporanluarprovinsi.vue?vue&type=template&id=886667ca&"
import script from "./laporanluarprovinsi.vue?vue&type=script&lang=js&"
export * from "./laporanluarprovinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports